/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { BankOutlined } from '@ant-design/icons';
import ClasificadorEconomico from 'views/Contabilidad/ClasificadorEconomico';
import NaturalezaDeIngresos from 'views/Contabilidad/Catalogos/NaturalezaDeIngreso';
import PresupuestoDeIngresos from 'views/Contabilidad/PresupuestoDeIngresos';
import Tipos from 'views/Contabilidad/CatalogosCri/Tipos';
import Clases from 'views/Contabilidad/CatalogosCri/Clases';
import Rubros from 'views/Contabilidad/CatalogosCri/Rubros';
// import CAAR from 'views/Contabilidad/CatalogosCri/CAAR';
import AfectacionesPresupuestales from 'views/Contabilidad/Catalogos/AfectacionPresupuestal';
import MomentoPresupuestalDelIngreso from 'views/Contabilidad/Catalogos/MomentoPresupuestalDelIngreso';
import MomentoPresupuestalDelEgreso from 'views/Contabilidad/Catalogos/MomentoPresupuestalDelEgreso';
import ClasificacionFuncional from 'views/Contabilidad/Catalogos/ClasificacionFuncional';
import Clasificaciones from 'views/Contabilidad/Catalogos/Clasificaciones';
import Naturalezas from 'views/Contabilidad/Catalogos/Naturalezas';
import TipCuentasContables from 'views/Contabilidad/Catalogos/TiposCuentasContables';
import ConceptoDeAcreditacion from 'views/Contabilidad/Catalogos/ConceptoDeAcreditacion';
import UnidadesResponsables from 'views/Configuracion/UnidadesResponsables';
import * as ReportesContabilidadOax from 'views/Recaudacion/ReportesDeContabilidadOaxaca';
// import Blank from './Blank';

export default
{
  title: 'Contabilidad',
  icon: () => <BankOutlined />,
  showInSidebar: true,
  type: 'private',
  children: [
    {
      title: 'Presupuesto de ingresos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: PresupuestoDeIngresos,
      permissionModel: 'presupuestodeingreso',
    },
    {
      title: 'Clasificador Económico',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: ClasificadorEconomico,
      permissionModel: 'clasificadoreconomico',
    },
    // {
    //   title: 'Clave Contable',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: Blank,
    //   permissionModel: 'clavecontable',
    // },
    // {
    //   title: 'Clave Presupuestal',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: Blank,
    //   permissionModel: 'clavepresupuestal',
    // },
    {
      title: 'Catálogos CRI',
      icon: null,
      showInSidebar: true,
      type: 'private',
      children: [
        {
          title: 'Rubros',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: Rubros,
          permissionModel: 'rubro',
        },
        {
          title: 'Tipos',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: Tipos,
          permissionModel: 'tipo',
        },
        {
          title: 'Clases',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: Clases,
          permissionModel: 'clase',
        },
        {
          title: 'CAAR',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: UnidadesResponsables,
          permissionModel: 'unidadresponsable',
        },
      ],
    },
    {
      title: 'Catálogos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      children: [
        {
          title: 'Clasificación Funcional',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: ClasificacionFuncional,
          permissionModel: 'clasificacionfuncional',
        },
        {
          title: 'Clasificaciones',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: Clasificaciones,
          permissionModel: 'clasificacion',
        },
        {
          title: 'Naturaleza',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: Naturalezas,
          permissionModel: 'naturaleza',
        },
        {
          title: 'Naturaleza de Ingresos',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: NaturalezaDeIngresos,
          permissionModel: 'naturalezadeingreso',
        },
        {
          title: 'Tipo de Cuenta Contable',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: TipCuentasContables,
          permissionModel: 'tipodecuentacontable',
        },
        {
          title: 'Afectaciones Presupuestales',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: AfectacionesPresupuestales,
          permissionModel: 'afectacionpresupuestal',
        },
        {
          title: 'Momento Presupuestal del Ingreso',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: MomentoPresupuestalDelIngreso,
          permissionModel: 'momentopresupuestaldelingreso',
        },
        {
          title: 'Momento Presupuestal del Egreso',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: MomentoPresupuestalDelEgreso,
          permissionModel: 'momentopresupuestaldelegreso',
        },
        {
          title: 'Conceptos de Acreditación',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: ConceptoDeAcreditacion,
          permissionModel: 'conceptodeacreditacion',
        },
      ],
    },
    {
      title: 'Reportes de Contabilidad',
      component: ReportesContabilidadOax.default,
      permissionConfig: ReportesContabilidadOax.permissionConfig,
    },
  ],
};
